import React, { useEffect, useState, useRef } from "react";
import moment from "moment";

import QueryDateRangePickerWrapper from "./QueryDateRangePickerWrapper";

const QueryDatePicker = (props) => {
  const node = useRef();

  const [open, setOpen] = useState(false);
  const [datepickerOffset, setDatepickerOffset] = useState();

  const handleToggleDropdown = (e) => {
    e.preventDefault();
    const position = e.target.getBoundingClientRect().right;
    if (position < 570) {
      setDatepickerOffset(0);
    }

    setOpen(!open);
  };

  const getSelectedDateName = () => {
    const startDate = moment(props.startDate).format("YYYY-MM-DD");
    const endDate = moment(props.endDate).format("YYYY-MM-DD");

    let currentDate =
      moment(props.startDate).format("MM/DD/YY") +
      "-" +
      moment(props.endDate).format("MM/DD/YY");

    const friendlyDateName = props.dateRanges.filter(
      (date) => startDate === date.from && endDate === date.to
    );

    if (friendlyDateName[0] && friendlyDateName[0].name !== undefined) {
      currentDate = friendlyDateName[0].name;
    }

    return currentDate;
  };

  const handleClickOutside = (e) => {
    if (e.target.classList.contains("datepicker-close-button")) {
      setOpen(false);
    }
    if (e.target.classList.contains("btn-apply")) {
      setTimeout(() => setOpen(false), 500);
    } else if (node.current && node.current.contains(e.target)) {
      return;
    } else {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", (e) => handleClickOutside(e));

    return () => {
      document.removeEventListener("mousedown", (e) => handleClickOutside(e));
    };
  }, []);

  let offsetStyle = { left: datepickerOffset };

  return (
    <>
      <div
        className="query-datepicker-open-button"
        onClick={(e) => handleToggleDropdown(e)}
      >
        <span>{getSelectedDateName()}</span>
      </div>
      <div ref={node} className="datepicker-container">
        {open && (
          <div
            className="datepicker-dropdown datepicker-dropdown--query"
            style={offsetStyle}
          >
            <QueryDateRangePickerWrapper
              {...props}
              selectedDate={getSelectedDateName()}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default QueryDatePicker;
